module.exports = __webpack_public_path__ + "img/slika38.5d63ae59.jpg";